import common from './common.json'
import output from './output.json'

export const enJson = {
  common,
  output,
}
